<template>
  <div v-if="intent">
    <v-layout style="border-bottom: 1px solid #eee" class="mb-3">
      <v-flex form-control :class="{ 'has-error': errors.has('intentName') }" class="pa-2">
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Conversation')"
          v-model="intent.intentname"
          name="intentName"
          :data-vv-as="$t('Conversation')"
          aria-describedby="Intent Name"
          v-validate="
            'required|excluded:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
          "
        />
        <span class="text-error" v-show="errors.has('intentName')">
          {{ errors.first('intentName') }}
        </span>
      </v-flex>
      <slot name="header"></slot>
    </v-layout>

    <div>
      <v-layout class="pa-4" justify="space-between">
        <v-flex xs12 sm6>
          <div style="max-height: 500px; overflow-y: auto ; border: 1px solid #eee" >
            <template v-for="flow in flows" >
              <div :key="flow.id">
                <div @click="flowid = (flowid != flow.id ? flow.id : null)">
                <v-layout>
                  <v-flex class="pl-3 py-3">
                    <div >{{ flow.flowname }}</div>
                    
                  </v-flex>
                  <v-flex class="pa-3" shrink>
                    <v-icon>{{flowid == flow.id  ? 'expand_less' : 'expand_more'}}</v-icon>
                  </v-flex>
                </v-layout>
                </div>

                <v-card flat v-if="flowid == flow.id">
                  <v-card-text>
                    <flow-node-manage :value="flow" @onSelect="onSelectNode"></flow-node-manage>
                  </v-card-text>
                </v-card>
              </div>
              <v-divider :key="'divider_'+ flow.id" />
            </template>
          </div>
        </v-flex>
        <v-flex class="d-flex text-center">
          <v-card-text class="hidden-xs-only">
            <div
              v-if="!selected"
              key="title"
              class="title font-weight-light grey--text pa-3 text-xs-center"
            >
              Select your node
            </div>
            <div v-else>
              <div class="title mb-4">{{ selected.intentname }}</div>
              <template v-if="selected.type == 'node' || selected.type == 'start_node'">
                <div
                  v-if="selected.answer.length == 0 || selected.answer[0].length == 0"
                  class="title font-weight-light grey--text pa-3 text-xs-center"
                >
                  Empty node
                </div>
                <template v-else>
                  <message-viewer v-model="selected.answer"></message-viewer>
                </template>
              </template>
              <template v-else-if="selected.type == 'api'">
                <div
                  v-if="selected.answer.length == 0 || selected.answer[0].length == 0"
                  class="title font-weight-light grey--text pa-3 text-xs-center"
                >
                  Empty node
                </div>
                <template v-else>
                  <v-layout>
                    <v-chip color="primary" disabled class="white--text">{{
                      selected.answer[0][0].api_method
                    }}</v-chip>
                    <v-flex class="pa-2">{{ selected.answer[0][0].api_name }}</v-flex>
                  </v-layout>
                </template>
              </template>
              <template v-else-if="selected.type == 'random'">
                <div
                  v-if="selected.answer.length == 0 || selected.answer[0].length == 0"
                  class="title font-weight-light grey--text pa-3 text-xs-center"
                >
                  Empty node
                </div>
                <template v-else>
                  <div v-for="(to, index) in selected.answer[0][0].to" :key="index">
                    <v-btn outline color="primary">Random {{ index + 1 }}</v-btn>
                  </div>
                </template>
              </template>
              <template v-else-if="selected.type == 'condition'">
                <div
                  v-if="selected.answer.length == 0 || selected.answer[0].length == 0"
                  class="title font-weight-light grey--text pa-3 text-xs-center"
                >
                  Empty node
                </div>
                <template v-else>
                  <template v-for="(condition, index) in selected.answer[0][0].condition">
                    <div class="font-weight-bold mt-2" :key="'title_' + index">
                      Case {{ index + 1 }}
                    </div>
                    <div :key="'condition_' + index" class="pa-3">{{ condition.caseText }}</div>
                    <v-divider
                      :key="'condition_divider' + index"
                      v-if="selected.answer[0][0].condition.length - 1 != index"
                    ></v-divider>
                  </template>
                </template>
              </template>
              <template v-else-if="selected.type == 'flow'">
                <div
                  v-if="selected.answer.length == 0 || selected.answer[0].length == 0"
                  class="title font-weight-light grey--text pa-3 text-xs-center"
                >
                  Empty node
                </div>
                <template v-else>
                  <v-layout wrap>
                    <v-flex xs4 class="pa-2 font-weight-bold">Flow Name</v-flex>
                    <v-flex xs8 class="pa-2">{{ selected.answer[0][0].flowname }}</v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs4 class="pa-2 font-weight-bold">Intent Name</v-flex>
                    <v-flex xs8 class="pa-2">{{ selected.answer[0][0].intentname }}</v-flex>
                  </v-layout>
                </template>
              </template>
            </div>
          </v-card-text>
        </v-flex>
      </v-layout>
    </div>
    <div class="text-xs-center">
      <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" depressed :disabled="!selected" @click="onSave">{{
        $t('Save')
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import FlowNodeManage from './FlowNodeManage'
import MessageViewer from './MessageViewer'
export default {
  props: ['value'],
  data() {
    return {
      flowid: null,
      excludedName: '',
      intent: null,
      selected: null,
    }
  },
  components: {
    FlowNodeManage,
    MessageViewer,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loading: 'getLoadingFlowList',
      selectedFlow: 'getFlowId',
    }),
  },
  mounted() {
    this.intent = JSON.parse(JSON.stringify(this.value))
    this.cached_intent = JSON.stringify(this.intent)
  },
  methods: {
    onCancel() {
      this.intent = JSON.parse(this.cached_intent)
      this.$emit('onCancel')
    },
    onSave() {
      var flow = this.flows.find((el) => {
        return el.id == this.selected.flowid
      })
      this.$set(this.intent, 'answer', [
        [
          {
            flowname: flow.flowname,
            intentname: this.selected.intentname,
          },
        ],
      ])
      this.$set(this.intent, 'connected_intents', [
        {
          type: 'flow',
          to: this.selected.id,
        },
      ])
      this.cached_intent = JSON.stringify(this.intent)
      this.$emit('onSave', this.intent)
    },
    onSelectNode(payload) {
      this.selected = payload
      try {
        this.selected.answer = JSON.parse(this.selected.answer)
      } catch (error) {}
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/flow/FlowManage.vue